export enum ValidatorKeyEnum {
  // ANGULAR
  REQUIRED = 'required',
  EMAIL = 'email',
  MAX_LENGTH = 'maxlength',
  MIN = 'min',
  PATTERN = 'pattern',

  // CUSTOMS
  SIRET = 'siret',
  POSTAL_CODE = 'postalCode',
  INVALID_DATE_AFTER = 'invalidDateAfter',
  INTEGER = 'integer',
  EMAIL_NOT_FOUND = 'emailNotFound',
  BAD_USER_ROLE = 'badUserRole',
  BAD_USER_NAME = 'badUserName',
  PHONE_NUMBER = 'phoneNumber',
  URL = 'url'
}
